import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const SalesReturn = () => {
  const data = [
    ['Month', 'Sales Returns'],
    ['January', 5],
    ['February', 4],
    ['March', 6],
    ['April', 5],
    ['May', 4],
  ];

  const options = {
    title: 'Sales Returns',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Returns (in Thousands)' },
    legend: { position: 'top' },
    bar: { groupWidth: '75%' },
    colors: ['#FF9800'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesReturn;